export default __webpack_public_path__ + "static/media/laptopDevice.502960ce.jpg";